import $ from "jquery";
var Brokers = /** @class */ (function () {
    function Brokers() {
        var _this = this;
        this.form = $("form");
        this.intouchInput = $("input[name=intouch]");
        this.newBrokersLink = $(".js-newbrokers");
        this.intouchLink = $(".js-intouch");
        this.brokerList = $(".broker-list");
        this.results = $(".results");
        if (window.pageData.email && window.mixpanel) {
            var m = new Date();
            var dateString = m.getUTCFullYear() + "/" + (m.getUTCMonth() + 1) + "/" + m.getUTCDate() + " " + m.getUTCHours() + ":" + m.getUTCMinutes() + ":" + m.getUTCSeconds();
            window.mixpanel.identify(window.pageData.email);
            window.mixpanel.people.set({
                "$email": window.pageData.email,
                "$created": dateString
            });
            window.mixpanel.track("Completed Search");
        }
        // window.pageData.skipAnimation = true;
        if (window.pageData.skipAnimation) {
            this.initAfterLoadingAnimation();
        }
        else {
            var nuggets = $(".wisdom-nugget");
            var max = nuggets.length - 1;
            var pos = Math.round(Math.random() * max);
            $(nuggets[pos]).addClass("active");
            setTimeout(function () {
                _this.initAfterLoadingAnimation();
            }, 3000);
        }
        this.form.on("submit", function () {
            if ($("[name=intouch]").val() != "true" && $("input[type=checkbox]:checked").length == 0) {
                $("body").addClass("no-brokers-selected");
                return false;
            }
        });
        this.newBrokersLink.on("click", function () {
            var url = window.pageData.url + "/" + window.pageData.language + "/brokers";
            $.ajax({
                url: url,
                method: "POST",
                data: {
                    submitted: "true",
                    newbrokers: "true"
                },
                success: function (result) {
                    var html = $(result);
                    var brokerList = html.find(".broker-list");
                    brokerList.find(".broker:not(.average-broker)").each(function (index, el) {
                        var id = $(el).attr("data-id");
                        if (_this.brokerList.find("[data-id=" + id + "]").length)
                            return;
                        _this.brokerList.append(el);
                        _this.bindBrokerEvents(el);
                        _this.checkIfToggleBioNeeded(el);
                    });
                    var classes = html.find(".results").attr("class");
                    _this.results.attr("class", classes);
                }
            });
            return false;
        });
        this.intouchLink.on("click", function () {
            _this.intouchInput.val("true");
            _this.form.submit();
        });
        $(window).resize(function () {
            _this.resize();
        });
    }
    Brokers.prototype.resize = function () {
        var _this = this;
        $(".broker").each(function (index, el) {
            _this.checkIfToggleBioNeeded(el);
        });
    };
    Brokers.prototype.initAfterLoadingAnimation = function () {
        var _this = this;
        $("body").addClass("done-loading");
        $(".broker").each(function (index, el) {
            _this.bindBrokerEvents(el);
            _this.checkIfToggleBioNeeded(el);
        });
        setTimeout(function () {
            $("body").addClass("post-load");
        }, 100);
    };
    Brokers.prototype.bindBrokerEvents = function (brokerEl) {
        var input = $(brokerEl).find(".broker-select input");
        input.on("change", function () {
            var checkbox = $(this);
            var broker = checkbox.parents(".broker");
            if (checkbox.is(":checked")) {
                broker.addClass("selected");
            }
            else {
                broker.removeClass("selected");
            }
        });
        var bio = $(brokerEl).find(".broker-bio");
        var bioToggle = $(brokerEl).find(".broker-bio-toggle");
        bioToggle.on("click", function () {
            if (bio.hasClass("expanded")) {
                bio.removeClass("expanded");
            }
            else {
                bio.addClass("expanded");
            }
        });
    };
    Brokers.prototype.checkIfToggleBioNeeded = function (brokerEl) {
        var lines = 4;
        var lineHeight = 17.5;
        var threshold = (lines + 0.5) * lineHeight;
        var bio = $(brokerEl).find(".broker-bio");
        var bioContent = bio.find(".broker-bio-content");
        var height = bioContent.height();
        if (height > threshold) {
            bio.addClass("toggle-needed");
        }
        else {
            bio.removeClass("toggle-needed");
            bio.removeClass("expanded");
        }
    };
    return Brokers;
}());
export { Brokers };
